var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHide = function SvgHide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.hideSvgColor{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hideSvgColor",
    d: "M12,6.5c2.8,0,5,2.2,5,5c0,0.6-0.1,1.2-0.4,1.8l2.9,2.9c1.5-1.3,2.7-2.9,3.4-4.8C21.2,7,16.9,4,12,4 c-1.4,0-2.7,0.2-4,0.7l2.2,2.2C10.8,6.6,11.4,6.5,12,6.5z M2,3.8l2.3,2.3l0.5,0.5c-1.7,1.3-3,3-3.7,5c2.4,6.1,9.2,9.1,15.3,6.7 c0,0,0,0,0.1,0l0.4,0.4l2.9,2.9l1.3-1.3L3.3,2.5L2,3.8z M7.5,9.3l1.5,1.6C9,11.1,9,11.3,9,11.5c0,1.7,1.3,3,3,3c0.2,0,0.4,0,0.6-0.1 l1.6,1.5c-2.5,1.2-5.4,0.2-6.7-2.2C6.8,12.4,6.8,10.7,7.5,9.3z M11.8,8.5l3.1,3.1l0-0.2c0-1.7-1.3-3-3-3L11.8,8.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hide.a9870486.svg";
export { ForwardRef as ReactComponent };